export const ProductSvg = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.1876 8.56023V0H18.8113V8.56023L9.76172 15.5001V40H30.237V15.5001L21.1876 8.56023ZM18.8112 14.931V17.1699H21.1875V14.931C21.9883 15.3577 22.5348 16.2011 22.5348 17.1699C22.5348 18.5679 21.3974 19.7053 19.9994 19.7053C18.6013 19.7053 17.464 18.568 17.464 17.1699C17.4639 16.201 18.0105 15.3577 18.8112 14.931ZM14.877 23.802H25.1216V26.1784H14.877V23.802ZM14.877 27.7629H25.1216V30.1392H14.877V27.7629ZM14.877 34.1V31.7237H25.1216V34.1H14.877Z'
        fill='#273BCD'
      />
    </svg>
  )
}
